import { render } from "./AgenteJornadaReportarIncidencia.vue?vue&type=template&id=dbab0444&scoped=true"
import script from "./AgenteJornadaReportarIncidencia.vue?vue&type=script&lang=ts"
export * from "./AgenteJornadaReportarIncidencia.vue?vue&type=script&lang=ts"

import "./AgenteJornadaReportarIncidencia.vue?vue&type=style&index=0&id=dbab0444&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-dbab0444"

export default script